export default __webpack_public_path__ + "static/media/benefit_3@2x.bf5f5a4f.png";